import { CustomModal } from '@amili-v3/amili-v3-design';
import styled from 'styled-components';

//export component
export const CustomModalExportStyle = styled(CustomModal)`
  .ant-modal-body {
    padding-inline: 52px;
  }

  .ant-modal-footer {
    justify-content: center;
    padding-top: 22px;
    button {
      width: 100%;
    }
  }

  .ant-checkbox-wrapper {
    padding: 7px 0;
  }
`;

//Upload file modal
export const UploadModalWrapper = styled(CustomModal)`
  .ant-modal-body {
    padding-bottom: 40px;
  }
  .upload-title {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .url-col-item {
    background-color: var(--error);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    &.ant-btn-default.primary:hover {
      background-color: var(--error);
    }
  }

  .ant-upload-wrapper.upload-drag {
    display: inherit;
    padding: 4px;
    border: 1px dashed var(--link);
    border-radius: 8px;
  }

  .upload-drag {
    .ant-upload.ant-upload-drag {
      padding: 40px 96px;
      background: var(--light-link);
      min-height: 220px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      .ant-upload-drag-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .ant-upload-text {
          color: var(--secondary);
        }
        .ant-avatar {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #cce4fa;
        }
      }
      .ant-upload-btn {
        width: unset;
        height: unset;
      }
    }

    .browse-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
    }
  }
`;
export const BodyConfirmModal = styled(CustomModal)`
  .ant-modal-title {
    .goback-btn {
      position: absolute;
      left: 40px;
      display: flex;
      align-items: center;
    }
  }

  .ant-modal-body {
    display: flex;
    align-items: center;

    .content-body {
      width: 70%;
      margin: auto;

      .icon-area {
        background-color: var(--error-opacity);
        width: fit-content;
        padding: 30px;
        border-radius: 50%;
        margin: 0 auto;
      }

      p {
        font-size: 15px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
`;

export const ExportProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  height: min(600px, 50vh);
`;
